import React, {memo} from 'react';
import {TouchableOpacity} from 'react-native';
import {createUseStyle} from "@redlink/assets/styles";
import {Space, Text} from "../atoms";

export const IconButtonItem = memo(({title, onPress, children}) => {
    const {styles} = useStyle();
    return <TouchableOpacity style={styles.iconButtonItemContainer} activeOpacity={.7} {...{onPress}}>
        {children}
        <Space size={4}/>
        <Text style={styles.iconButtonIconTitle}>{title}</Text>
    </TouchableOpacity>
})


const useStyle = createUseStyle(({colors, shadow, size}) => ({
    iconButtonItemContainer: {
        flexDirection: 'row',
        paddingVertical: 4,
        alignItems: 'center'
    },
    iconButtonIconTitle: {
        fontSize: 14,
        color: colors.gray23,
    },
}));
